import Vue from 'vue';

Vue.component( 'selector-articulos', () => import( '@com/selectores/selector-articulos.vue' ) );
Vue.component( 'selector-codigospostales', () => import( '@com/selectores/selector-codigospostales.vue' ) );
Vue.component( 'selector-localidades', () => import( '@com/selectores/selector-localidades.vue' ) );
Vue.component( 'selector-provincias', () => import( '@com/selectores/selector-provincias.vue' ) );
Vue.component( 'selector-transportes', () => import( '@com/selectores/selector-transportes.vue' ) );
